const PILOTS = {
  SORT_BY: {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
  },
}

export { PILOTS }
